import 'whatwg-fetch'

import queryString from 'query-string'
import { getCookie, removeCookie, setCookie } from 'tiny-cookie'

import modal from '../Modal/Modal'

const countrySelector = {
  attach_listeners: (storeCountryCodeMapping) => {
    document.body.addEventListener('click', (e) => {
      if (e.target.dataset && e.target.dataset.storedCountry) {
        e.preventDefault()

        if (e.target.dataset.reload) {
          removeCookie('stored-country')
          removeCookie('stored-country-modal')

          window.location.href = `${e.target.href}?store=${e.target.dataset.storedCountry}`
        } else {
          setCookie('seedlip-stored-country', e.target.dataset.storedCountry, { expires: '1M' })
          setCookie('seedlip-stored-country-modal', true, { expires: '1M' })

          document.body.classList.remove('modal--specific-store--active')
          countrySelector.update_button_label(
            e.target.dataset.storedCountry,
            e.target.dataset.storedCountry,
            storeCountryCodeMapping,
          )
        }
      }
    })
  },

  create_modal: (userCountryCode, siteRealCountryCode, storeCountryCodeMapping) => {
    const usersStore = Object.keys(storeCountryCodeMapping).filter((key) => {
      const condition = storeCountryCodeMapping[key].countryCode === userCountryCode
      return condition
    })

    const defaultsStore = Object.keys(storeCountryCodeMapping).filter((key) => {
      const condition = storeCountryCodeMapping[key].countryCode === siteRealCountryCode
      return condition
    })

    const defaultStore = storeCountryCodeMapping[defaultsStore]
    const store = storeCountryCodeMapping[usersStore] || storeCountryCodeMapping['United Kingdom']

    let markup = ''

    if (usersStore.length) {
      markup += `<h1 class="c-modal__title">Visiting from <br> ${usersStore}?</h1>`
    } else {
      markup += `<h1 class="c-modal__title">Visiting from <br> outside ${defaultsStore}?</h1>`
    }

    markup += `
            <p>Seedlip is available to purchase in ${store.visualCC.toUpperCase()}. <br> Click below to visit our ${store.visualCC.toUpperCase()} store.</p>
            <p>
                <a href="#" class="c-btn c-btn--ghost" data-stored-country="${defaultStore.countryCode}" data-stored-visualcc="${defaultStore.visualCC}">Close</a>
                <a href="${store.url}" class="c-btn" data-stored-country="${store.countryCode}" data-stored-visualcc="${store.visualCC}" data-reload="true">${store.visualCC.toUpperCase()} Store</a>
            </p>
            <a href="/" class="c-modal__close" data-stored-country="${defaultStore.countryCode}" data-stored-visualcc="${defaultStore.visualCC}" style="background-image: url(//cdn.shopify.com/s/files/1/1255/7471/t/4/assets/modal-cross.png?16232418014865252946)">
                <span>Close modal</span>
            </a>
        `

    return markup
  },

  enable: async (consent = true) => {
    const storeCountryCodeMapping = {
      Canada: {
        countryCode: 'ca',
        url: '//www.seedlipdrinks-ca.com',
        visualCC: 'ca',
      },
      'United Kingdom': {
        countryCode: 'gb',
        url: '//www.seedlipdrinks.com',
        visualCC: 'uk',
      },
      'United States': {
        countryCode: 'us',
        url: '//www.seedlipdrinks-us.com',
        visualCC: 'us',
      },
    }

    const qs = queryString.parse(window.location.search)

    if (qs.store) {
      setCookie('seedlip-stored-country', qs.store, { expires: '1M' })
    }

    const userRealCountryCode = consent ? await countrySelector.fetch_country() : 'gb'
    const siteRealCountryCode = storeCountryCodeMapping[window.store_country].countryCode || 'gb'
    const storeCountryCode = getCookie('seedlip-stored-country')
    const storeCountryCodeModal = getCookie('seedlip-stored-country-modal')

    countrySelector.attach_listeners(storeCountryCodeMapping)
    countrySelector.update_button_label(siteRealCountryCode, storeCountryCode, storeCountryCodeMapping)

    modal.show_discount(userRealCountryCode, storeCountryCode, storeCountryCodeModal)

    if (userRealCountryCode === 'au') {
      modal.show_au(userRealCountryCode)
    }

    if (userRealCountryCode === 'nz') {
      modal.show_nz(userRealCountryCode)
    }

    if (storeCountryCode && storeCountryCodeModal) {

      // nothing

    } else if (storeCountryCode && storeCountryCode !== siteRealCountryCode) {

      countrySelector.show_modal(storeCountryCode, siteRealCountryCode, storeCountryCodeMapping)

    } else if (storeCountryCode && storeCountryCode === userRealCountryCode) {

      // nothing

    } else if (storeCountryCode && storeCountryCode === siteRealCountryCode) {

      // nothing

    } else if (storeCountryCode && storeCountryCode !== userRealCountryCode) {

      countrySelector.show_modal(storeCountryCode, siteRealCountryCode, storeCountryCodeMapping)

    } else if (!storeCountryCode && siteRealCountryCode === userRealCountryCode) {

      // nothing

    } else if (!storeCountryCode && siteRealCountryCode !== userRealCountryCode) {

      const notCanadianOnGb = (siteRealCountryCode === 'gb' && userRealCountryCode !== 'ca')
      const notAmericanOnGb = (siteRealCountryCode === 'gb' && userRealCountryCode !== 'us')

      if (notCanadianOnGb && notAmericanOnGb) {
        return
      }

      countrySelector.show_modal(userRealCountryCode, siteRealCountryCode, storeCountryCodeMapping)

    } else {

      // nothing

    }
  },

  fetch_country: () => {
    return fetch('https://us-central1-microip-896b5.cloudfunctions.net/location/')
      .then(res => res.json())
      .then((res) => {
        let cc = res.country
        if (cc) {
          cc = cc.toLowerCase()
        } else {
          cc = 'gb'
        }

        return cc
      })
      .catch((err) => {
        console.error(err)
      })
  },

  show_modal: (userRealCountryCode, siteRealCountryCode, storeCountryCodeMapping) => {
    const modalContainer = document.querySelector('.c-modal--specific-store .c-modal__inner')
    const markup = countrySelector.create_modal(
      userRealCountryCode,
      siteRealCountryCode,
      storeCountryCodeMapping,
    )

    modalContainer.innerHTML = markup

    document.body.classList.add('modal--specific-store--active')
  },

  update_button_label: (siteCountryCode, userCountryCode, storeCountryCodeMapping) => {
    let thisUserCountryCode = userCountryCode

    if (!thisUserCountryCode) {
      thisUserCountryCode = siteCountryCode
    }

    const usersStore = Object.keys(storeCountryCodeMapping).filter((key) => {
      const condition = storeCountryCodeMapping[key].countryCode === thisUserCountryCode
      return condition
    })

    const store = storeCountryCodeMapping[usersStore]

    document.querySelector('.c-navigation__country-selector').text = store.visualCC
  },
}

export default countrySelector
